import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import AboutUs from "./AboutUs";
import Achievements from "./Achievements";
import Discovery from "./Discovery";
import PropertyFeature from "./PropertyFeature";
import PropertyHomeSection from "./PropertyHomeSection";
import Services from "./Services";
import Categories from "../common/Categories";
import Testimonials from "../common/Testimonials";
import Newsletter from "../common/Newsletter";

const PropertyDemo1Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <PropertyHomeSection />
      <PropertyFeature />
      <AboutUs />
      <Categories type="property_demo1" />
      <Services />
      <Discovery />
      <Achievements />
      <Testimonials type="property_demo1" />
      <Newsletter type="property_demo1" />
    </>
  );
};

export default PropertyDemo1Container;
